export interface AccruedInterest {
  date: string
  databaseBODAccrual: number
  databaseEODAccrual: number
  calculatedBODAccrual: number
  llaBODAccrual?: number
  llaEODAccrual?: number
}

export enum InterestFormat {
  Decimal,
  Dollar,
}
